export enum ENUM_DIGITAL_SIGNATURE_AUTH {
  REGISTRATION = "registration",
  LOGIN = "login",
}

export enum ENUM_DIGITAL_LOGIN_TYPE {
  PASSWORD = "password",
  CERTIFICATE = "certificate",
}
